import { render } from "./IncomeRow.vue?vue&type=template&id=4fa752fa&scoped=true"
import script from "./IncomeRow.vue?vue&type=script&lang=js"
export * from "./IncomeRow.vue?vue&type=script&lang=js"

import "./IncomeRow.vue?vue&type=style&index=0&id=4fa752fa&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa752fa"]])

export default __exports__